import {ru} from './ru';
import {en} from './en';
import {es} from './es';
import {bn} from './bn';
import {pt} from './pt';
import {de} from './de';
import {it} from './it';
import {pl} from './pl';
import {fr} from './fr';
import {hi} from './hi';
import {ms} from './ms';

export const translates = {
    ru,
    en,
    es,
    bn,
    pt,
    de,
    it,
    fr,
    pl,
    hi,
    ms
};
